import React from "react";
const SvgIcon = ({ src = "", size = 20, label }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    aria-labelledby={label}>
    <image href={src} width={size} height={size} />
  </svg>
);

export default SvgIcon;
